<div class="video-wrapper">
  <video [ngClass]="{ hidden: isLoading || isError }"
         (loadedmetadata)="onMetadataLoaded()"
         (timeupdate)="onTimeUpdate()"
         #video
         class="video"
         width="280"
         [controls]="false"
         [muted]="true"
         playsinline
         [autoplay]="autoplay"
         preload="none"
  >
  </video>

  @if (isLoading || isError) {
    <div class="video-empty"
    >
      @if (isLoading) {
        <mat-spinner></mat-spinner>
        <!--<span *ngIf="!isLoading && isError">No video</span>-->
          <!--<button mat-icon-button
                  *ngIf="!isLoading && isError && liveMode"
                  (click)="refresh()"
          >
              <mat-icon>refresh</mat-icon>
          </button>-->
      }
    </div>
  }

  <div class="video-controls">
    @if (!isError) {
      <button mat-icon-button
                (click)="onPlayPauseClick()"
        >
        @if (video.paused) {
          <mat-icon>play_arrow</mat-icon>
        } @else {
          <mat-icon>pause</mat-icon>
        }
      </button>
    }

    @if (browserSupportsFullScreen && !isError) {
      <button mat-icon-button
                (click)="onFullScreen()"
        >
        <mat-icon>fullscreen</mat-icon>
      </button>
    }

    @if (!!timeFrom && !timeTo) {
      <button mat-button
              (click)="onLiveToggle()"
      >
        @if (liveMode) {
          <span>Go to Shift Start</span>
        } @else {
          <span>Switch to Live</span>
        }
      </button>
    }
  </div>

  <div class="progress-info-text" [ngClass]="{'hidden': liveMode}">
    @if (!!currentTime) {
      <div><span>{{ currentTime | hoursMinutesSeconds }}</span></div>
    }

    @if (!!timeFrom && !!currentTime) {
      <div><span>{{ (absUnixTime * 1000) | date:'mediumTime' }}</span></div>
    }
  </div>

  <div class="progress-info-text" [ngClass]="{'hidden': !liveMode}">
    @if (!!liveDiff) {
      <div><span>Live - {{ (liveDiff / 1000).toFixed(1) }} seconds</span></div>
    }
  </div>

  <div class="progress-bar" [ngClass]="{'hidden': liveMode}">
      <div class="progress">
          <progress #progress value="0" (click)="onProgressClick($event)">
          </progress>
      </div>
  </div>

</div>
